import {
  Alert,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import FinanceiroService from "services/financeiro";
import { dataCalendario } from "utils/dataCalendario";

const iso = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

/** Chip "Fechado até dd/mm" + diálogo para avançar/reabrir o fechamento. */
export default function FechamentoPeriodo({ onAlterado }) {
  const [dados, setDados] = useState(null);
  const [aberto, setAberto] = useState(false);
  const [data, setData] = useState("");
  const [motivo, setMotivo] = useState("");
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);

  const carregar = () =>
    FinanceiroService.fechamento()
      .then((r) => setDados(r))
      .catch(() => setDados({ dataFechamento: null, historico: [] }));

  useEffect(() => {
    carregar();
  }, []);

  const atual = iso(dados?.dataFechamento);
  const reabrindo = atual && (!data || data < atual);

  const salvar = async () => {
    setSalvando(true);
    setErro("");
    try {
      await FinanceiroService.alterarFechamento(data || null, motivo);
      await carregar();
      setAberto(false);
      onAlterado?.();
    } catch (e) {
      setErro(e?.error || e?.message || "Erro ao alterar o fechamento.");
    }
    setSalvando(false);
  };

  return (
    <>
      <Chip
        icon={<span style={{ marginLeft: 8 }}>🔒</span>}
        label={
          dados?.dataFechamento
            ? `Período fechado até ${dataCalendario(dados.dataFechamento)}`
            : "Nenhum período fechado"
        }
        onClick={() => {
          setData(atual);
          setMotivo("");
          setErro("");
          setAberto(true);
        }}
        sx={{
          backgroundColor: "#fff !important",
          color: "#344767 !important",
          fontWeight: 500,
        }}
      />
      <Dialog
        open={aberto}
        onClose={() => setAberto(false)}
        maxWidth="sm"
        fullWidth
        sx={{ zIndex: 10000 }}
      >
        <DialogTitle>Fechamento do financeiro</DialogTitle>
        <DialogContent>
          <Typography variant="body2" mb={2}>
            Tudo que foi pago, recebido, baixado ou lançado até esta data fica
            travado: não dá para alterar valor, data, status ou conta bancária,
            nem excluir. Use depois de conciliar o mês. Só administrador pode
            voltar a data (reabrir).
          </Typography>
          <TextField
            label="Fechado até"
            type="date"
            value={data}
            onChange={(e) => setData(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          {reabrindo && (
            <TextField
              label="Motivo da reabertura"
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              fullWidth
              sx={{ mt: 2 }}
            />
          )}
          {erro && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {erro}
            </Alert>
          )}
          {dados?.historico?.length > 0 && (
            <Box mt={3}>
              <Typography variant="subtitle2">Histórico</Typography>
              {dados.historico.map((h, i) => (
                <Typography
                  key={i}
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  {new Date(h.em).toLocaleString("pt-BR")} ·{" "}
                  {h.usuario?.name || "?"}:{" "}
                  {h.de ? dataCalendario(h.de) : "aberto"} →{" "}
                  {h.para ? dataCalendario(h.para) : "aberto"}
                  {h.motivo ? ` (${h.motivo})` : ""}
                </Typography>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAberto(false)}>Cancelar</Button>
          <Button
            variant="contained"
            sx={{ color: "white !important" }}
            disabled={salvando}
            onClick={salvar}
          >
            {reabrindo ? "Reabrir" : "Fechar período"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
